"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyConfirmRequest = void 0;
var ApplyConfirmRequest = /** @class */ (function () {
    function ApplyConfirmRequest() {
    }
    return ApplyConfirmRequest;
}());
exports.ApplyConfirmRequest = ApplyConfirmRequest;
;
//# sourceMappingURL=applyConfirm.request.js.map